import slugify from "slugify"

export const formatFunnelUri = (type, jahr, kategorie) =>
  `/${type.toLowerCase()}/${jahr ? `${jahr}/` : ""}${slugify(kategorie, {
    lower: true,
    trim: true,
    locale: "de",
  })}`
